<template>
  <v-card
    flat
  >
    <v-toolbar
      dark
      color="primary"
    >
      <v-btn
        icon
        dark
        @click="$emit('dialog-close')"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-toolbar-title>Withdraw Funds</v-toolbar-title>
    </v-toolbar>

    <v-card-text>
      <v-form
        ref="form"
        v-model="valid"
        lazy-validation
        class="mt-5"
      >
        <v-text-field
          label="Amount"
          v-model="fundsOut"
          prefix="$"
          :rules="[rules.number]"
        ></v-text-field>

        <v-select
          v-model="method"
          :items="methods"
          :hint="methods.label"
          item-text="label"
          item-value="value"
          label="Repayment Method"
          persistent-hint
          :rules="[rules.required]"
        ></v-select>

        <v-text-field
          label="Account Identifier"
          v-model="accountIdentifier"
          :hint="idHint[method]"
          persistent-hint
          :rules="[rules.required]"
        ></v-text-field>
      </v-form>
    </v-card-text>

    <v-card-actions>
      <v-btn
        color="primary"
        :loading="loading"
        :disabled="loading"
        @click="withdrawReq"
      >
        <v-icon left>
          mdi-cash-multiple
        </v-icon>
        Withdraw
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'

  export default {
    name: 'WithdrawalForm',

    components: {
    },

    computed: {
      ...mapGetters([
        'user'
      ])
    },

    data: () => ({
      // From handling.
      loading: false,
      valid: true,

      methods: [
        { label: 'Venmo', value: 'venmo' },
        { label: 'PayPal', value: 'paypal' },
        { label: 'Zelle', value: 'zelle' }
      ],

      idHint: {
        venmo: 'Your Venmo Id. For example @myvenmo',
        paypal: 'Your PayPal Id, usually the email you use with PayPal.',
        zelle: 'Your Zelle Id, typically the email or phone number you use with Zelle.'
      },

      // validation rules
      rules: {
        number: value => {
          return !isNaN(parseFloat(value)) && isFinite(value) || 'Must be numeric.'
        },
        required: value => !!value || 'This field is required.'
      },

      // Funding
      integrationId: null,
      fundsOut: null,
      method: null,
      accountIdentifier: null
    }),

    methods: {
      ...mapActions([
        'fundOut',
        'getTransactionHistory',
        'getWalletBalance'
      ]),

      // Request Funds Withdrawal.
      withdrawReq: function () {
        this.loading = true

        // Check validation
        this.valid = this.$refs.form.validate()

        if (this.valid == true) {
          let payload = {
            amount: this.fundsOut,
            notes: 'funds out request',
            method: this.method,
            accountIdentifier: this.accountIdentifier
            //userIntegrationId: this.integrationId
          }

          // Post.
          this.fundOut(payload).then(() => {
            this.getWalletBalance()
            this.getTransactionHistory()
          }).finally(() => {
            // Close everything out.
            this.$emit('dialog-close')
            this.loading = false
          })
        }
        else {
          this.loading = false
        }
      }
    }
  }
</script>
